import React from 'react';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useDispatch } from "react-redux";
import config from '../../../src/config/enviroment';
var CaptchaComponent = function (props) {
    var dispatch = useDispatch();
    return React.createElement(GoogleReCaptchaProvider, { reCaptchaKey: config.CaptchaKey, language: "ES", useRecaptchaNet: true }, props.children);
};
export default CaptchaComponent;
